import { render, staticRenderFns } from "./hasElectricNetworkLessThanTenYears.vue?vue&type=template&id=7f6ed6fa&scoped=true"
import script from "./hasElectricNetworkLessThanTenYears.vue?vue&type=script&lang=ts"
export * from "./hasElectricNetworkLessThanTenYears.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ed6fa",
  null
  
)

export default component.exports